import StudentLevelsDao from '../dao/student-levels.dao';
import type { StudentLevels } from '../interfaces';
import type { Environment } from '../interfaces/environment';

export abstract class StudentLevelsService {
  static getStudentLevels(
    env: Environment,
    contactId: string
  ): Promise<StudentLevels[]> {
    return StudentLevelsDao.getStudentLevels(env, contactId);
  }
}
